module.exports = __webpack_public_path__ + "img/plate_photo_6.567ae5bb.jpg";